import * as Yup from 'yup';

export const buildAttachmentSchema = (isEditMode) =>
  Yup.object({
    FileName: isEditMode
      ? Yup.string().trim().required('File name cannot be empty')
      : Yup.string().notRequired(),
  });
